module.exports = __webpack_public_path__ + "img/gb-wls.2d554424.svg";